export default {"src":"/_next/static/media/volume-off.c5adf215.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};